import api from './api'

// TODO: Add typing for [schedule]
const saveSchedule = (schedule: any): Promise<unknown> =>
    api<unknown>({
        method: schedule.id ? 'PUT' : 'POST',
        path: '/schedules',
        body: schedule,
    })

export default saveSchedule
